import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import './Biography.css';

const Biography = () => {
  const [language, setLanguage] = useState('EN');

  const biographyContent = {
    EN: {
      title: "BIOGRAPHY",
      content: [
        "Tahir spent his early childhood in Nurhak and Elbistan (Turkey), where he was influenced musically by the local Alevi Asik's and Dede's which eventually helped him develop a unique yet authentic musical style.",
        "He moved to London at the age of 10 where he later had the opportunity to work with musicians from all over the world. The first professional production that he was involved in, Arzuhal, Songs of Ozan Figani was released by Kalan in Turkey.",
        "Tahir later signed up with M&MT to produce his first solo album 'O' with Erkan Ogur.",
        "He was invited to perform in Poland by Raphael Roginski, where he had the opportunity to tour many towns and cities in Poland, introducing Alevi music to Polish audience accompanied by Cigdem Aslan.",
        "With his traditional Dede Sazi from Maras region, he performed in festivals such as WOMAD and Songlines Encounters along with renowned concert halls like Royal Albert Hall.",
        "Based in London, Tahir Palali continues to compose and perform songs that has immanent and mystic values in Alevi-Bektasi tradition."
      ]
    },
    TR: {
      title: "BİYOGRAFİ",
      content: [
        "Çocuk yaşta ayrıldığı Maraş yöresinin aşık ve dedelerinin tınılarından yola çıkıp, muhabbet geleneği içerisinde yetişmesinin de etkisiyle, yenilikçi ama özüne sadık kalan otantik bir tarz sunuyor.",
        "Londra'da geçirdiği süre içerisinde dünyanın dört bir yanından gelen müzisyenlerle çalışma fırsatı buldu. Ozan Figani'nin Kalan müzik etiketiyle yayınlanan 'Arzuhal' adlı albümüne müzik yönetmenliği yaptı.",
        "Prodüktörlüğünü Erkan Oğur'un üstlendiği 'O' isimli ilk solo albüm çalışmasında, her ne kadar batılı enstrümanlara yer vermesede, geleneksel yapının yanı sıra batı tınılarını da benimseyerek çalışmasına dahil etti.",
        "Polonyalı müzisyen Raphael Roginski ve Londrada yaşayan Cigdem Aslan'la 'Nefesh' projesi'ne öncülük edip anadolu deyişleri ve türkülerini Polonya'nın dört bir yanında konserler vererek farklı kitlelere taşıdı.",
        "Dünya müziğinin en önemli etkinliklerinden WOMAD ve Songlines gibi festivallerde yer almasının yanı sıra, Royal Albert Hall gibi prestijli konser salonlarında da dede sazıyla sahne alıp yöresel tınıları 'dünya müziği' dinleyicisyle tanıştırdı.",
        "Yaşamını Londra'da sürdüren Tahir Palali, dede sazı ve temburuyla besteler yapıp, çoğunluğu alevi-bektaşi geleneğinde bâtıni değerler taşıyan eserler icra ediyor."
      ]
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === 'EN' ? 'TR' : 'EN');
  };

  return (
    <div className="biography-page">
      <Navigation />
      
      <div className="biography-content">
        <div className="biography-header">
          <h1 className="page-title">{biographyContent[language].title}</h1>
          <button className="language-toggle" onClick={toggleLanguage}>
            {language === 'EN' ? 'TR' : 'EN'}
          </button>
        </div>
        
        <div className="biography-main">
          <div className="biography-image">
            <img 
              src={require('../assets/images/DSCF7047.jpg')} 
              alt="Tahir Palali Portrait" 
              className="portrait-image"
            />
          </div>
          
          <div className="biography-text">
            <div className="artist-name">TAHIR PALALI</div>
            <div className="bio-content">
              {biographyContent[language].content.map((paragraph, index) => (
                <p key={index} className="bio-paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
        
        <div className="biography-footer">
          <div className="achievements">
            <h3>Notable Performances</h3>
            <ul>
              <li>WOMAD Festival</li>
              <li>Songlines Encounters</li>
              <li>Royal Albert Hall</li>
              <li>Tours across Poland</li>
            </ul>
          </div>
          
          <div className="collaborations">
            <h3>Key Collaborations</h3>
            <ul>
              <li>Erkan Ogur (Album 'O')</li>
              <li>Raphael Roginski (Nefesh Project)</li>
              <li>Cigdem Aslan</li>
              <li>Kalan Music (Arzuhal)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Biography;